import axios from "axios";
import { useEffect, useState } from "react";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import { useLocation, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Skeleton } from "@material-ui/lab";
import {
    Button,
    Card,
    CircularProgress,
    Grid,
    InputLabel,
    makeStyles,
} from "@material-ui/core";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { InputField } from "../ccmode2.0/CcmodeSetupNew/FormFields";
import { TfiSave } from "react-icons/tfi";
import { SwalWarn } from "../Popup";
import { TbArrowsExchange2 } from "react-icons/tb";

const shopUrlValidation = Yup.object().shape({
    shopUrl: Yup.string().required("shop url is required"),
});

const useStyles = makeStyles((theme) => ({
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
    copyInner: {
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            flexGrow: 1,
        },
    },
    textField: {
        "& .MuiInputBase-input.Mui-disabled": {
            padding: "12.5px 14px",
        },
    },
    cardContainer: {
        padding: theme.spacing(5),
        width: "65%",
        margin: "0 auto",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            padding: theme.spacing(2),
        },
    },
}));

const ShopifyAppInstallForm = ({ feedsetting, language, setup = false }) => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();

    const [componentLoading, setComponentLoading] = useState(false);
    const [changeStore, setChangeStore] = useState(
        feedsetting?.shopify_shop ? false : true
    );

    useEffect(() => {
        if (location?.search.length > 0) {
            const params = new URLSearchParams(location.search);
            const urlParams = Object.fromEntries(params.entries());
            if (
                urlParams?.code &&
                urlParams?.hmac &&
                urlParams?.host &&
                urlParams?.shop &&
                urlParams?.state
            ) {
                setComponentLoading(true);
                axios({
                    method: "POST",
                    url: `${NODE_API_URL}/INTL/shopify/callback`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get(
                            "cust_auth_token"
                        )}`,
                    },
                    data: urlParams,
                })
                    .then((res) => {
                        if (res && res.data && res.data.success) {
                            toast.success(res.data.message);
                            if (
                                !Boolean(feedsetting.has_seen_dashboard_popup)
                            ) {
                                history.push({
                                    pathname: "/diamondfeed",
                                });
                            } else {
                                history.replace({
                                    pathname: location.pathname,
                                    search: "",
                                    state: undefined,
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        if (
                            error?.response?.data?.message === "UnAuthorized!"
                        ) {
                            var cookies = document.cookie.split(";");
                            for (var i = 0; i < cookies.length; i++) {
                                if (
                                    cookies[i] &&
                                    !cookies[i].includes("view")
                                ) {
                                    var equals = cookies[i].indexOf("=");
                                    var name =
                                        equals > -1
                                            ? cookies[i].substr(0, equals)
                                            : cookies[i];
                                    document.cookie =
                                        name +
                                        "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                                }
                            }

                            window.location.replace(`${BASE_URL}/logout`);
                        } else if (error?.response?.data?.message) {
                            toast.error(error.response.data.message);
                        } else {
                            toast.error(error.message);
                        }
                    })
                    .finally(() => setComponentLoading(false));
            }
        }
    }, [location.search]);

    const formik = useFormik({
        initialValues: {
            shopUrl: feedsetting?.shopify_shop
                ? new URL(`https://${feedsetting.shopify_shop}`).origin
                : "",
        },
        enableReinitialize: true,
        validationSchema: shopUrlValidation,
        onSubmit: handleSubmit,
    });

    async function handleSubmit(values, actions) {
        if (feedsetting?.shopify_shop && !changeStore) {
            setChangeStore(true);
            return;
        }

        actions.setSubmitting(true);
        try {
            const response = await axios.get(
                `${NODE_API_URL}/INTL/shopify/install?shop=${values.shopUrl}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get(
                            "cust_auth_token"
                        )}`,
                    },
                }
            );

            if (response && response.data && response.data.success) {
                window.open(response.data.data, "_self");
            }
        } catch (error) {
            if (error?.response?.data?.message === "UnAuthorized!") {
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                    if (cookies[i] && !cookies[i].includes("view")) {
                        var equals = cookies[i].indexOf("=");
                        var name =
                            equals > -1
                                ? cookies[i].substr(0, equals)
                                : cookies[i];
                        document.cookie =
                            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                }

                window.location.replace(`${BASE_URL}/logout`);
            } else if (error?.response?.data?.message) {
                formik.setFieldError("shopUrl", error.response.data.message);
            } else {
                formik.setFieldError("shopUrl", error.message);
            }
        } finally {
            actions.setSubmitting(false);
        }
    }

    if (!feedsetting || componentLoading) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    if (setup) {
        return (
            <Card className={classes.cardContainer}>
                <InstallForm
                    formik={formik}
                    feedsetting={feedsetting}
                    setChangeStore={setChangeStore}
                    disableChangeStore={false}
                    setup={setup}
                />
            </Card>
        );
    }

    return (
        <InstallForm
            formik={formik}
            feedsetting={feedsetting}
            setChangeStore={setChangeStore}
            disableChangeStore={!changeStore}
            setup={setup}
        />
    );
};

export default ShopifyAppInstallForm;

function InstallForm({
    formik,
    feedsetting,
    setChangeStore,
    disableChangeStore = true,
    setup,
}) {
    const classes = useStyles();

    const [swalopen, setSwalOpen] = useState({
        open: false,
        message: "",
        okFunction: null,
    });

    return (
        <>
            <FormikProvider value={formik}>
                <Form id="shopifyShopUrl">
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Install App On Shopify
                                <span className="small d-block mt-2 line-height-lg">
                                    Enter the url of your shopify store.
                                </span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputField
                                className={classes.textField}
                                fullWidth
                                disabled={disableChangeStore}
                                name="shopUrl"
                                value={formik.values?.shopUrl || ""}
                                InputProps={{
                                    style: {
                                        height: "40px",
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item style={{ marginLeft: "auto" }}>
                            {!disableChangeStore &&
                            feedsetting?.shopify_shop ? (
                                <Button
                                    disabled={formik.isSubmitting}
                                    variant="contained"
                                    color="primary"
                                    className={`${classes.saveBtn} mr-4`}
                                    onClick={() => setChangeStore(false)}
                                >
                                    cancel
                                    {formik.isSubmitting && (
                                        <CircularProgress
                                            size={16}
                                            className={"ml-3"}
                                        />
                                    )}
                                </Button>
                            ) : (
                                ""
                            )}
                            <Button
                                disabled={formik.isSubmitting}
                                variant="contained"
                                color="primary"
                                className={classes.saveBtn}
                                onClick={() => {
                                    if (setup) {
                                        formik.submitForm();
                                    } else {
                                        if (
                                            feedsetting?.shopify_shop &&
                                            disableChangeStore
                                        ) {
                                            setChangeStore(true);
                                            return;
                                        } else {
                                            setSwalOpen({
                                                open: true,
                                                message:
                                                    "Are You Sure You Want To Change The Store?",
                                                okFunction: () =>
                                                    formik.submitForm(),
                                            });
                                        }
                                    }
                                }}
                            >
                                {feedsetting?.shopify_shop &&
                                disableChangeStore ? (
                                    <>
                                        <TbArrowsExchange2
                                            className="mr-3"
                                            size={13}
                                        />{" "}
                                        Change Store
                                    </>
                                ) : (
                                    <>
                                        {setup ? (
                                            <>
                                                <TfiSave
                                                    className="mr-3"
                                                    size={13}
                                                />{" "}
                                                Install
                                            </>
                                        ) : (
                                            <>
                                                <TbArrowsExchange2
                                                    className="mr-3"
                                                    size={13}
                                                />{" "}
                                                Change
                                            </>
                                        )}
                                    </>
                                )}
                                {formik.isSubmitting && (
                                    <CircularProgress
                                        size={16}
                                        className={"ml-3"}
                                    />
                                )}
                            </Button>
                        </Grid>
                        {feedsetting.feed_type === "SHOPIFY APP RING" ? (
                            <>
                                {setup ? (
                                    <Grid
                                        item
                                        md={12}
                                        style={{ textTransform: "capitalize" }}
                                    >
                                        <hr className="w-100" />
                                        <h5>
                                            Follow these steps to install the
                                            app on your Shopify store:
                                        </h5>
                                        {(() => {
                                            const STEPS = [
                                                "Enter your Shopify store URL and click Install.",
                                                "Log into your Shopify admin account.",
                                                "When prompted, confirm the app installation",
                                                "After installation, you will be redirected to the Shopify Settings page.",
                                            ];

                                            return (
                                                <div className="p-4">
                                                    {STEPS.map((step, idx) => (
                                                        <li
                                                            key={idx}
                                                            className="font-size-lg text-semibold my-1"
                                                        >
                                                            {step}
                                                        </li>
                                                    ))}
                                                </div>
                                            );
                                        })()}
                                    </Grid>
                                ) : (
                                    <Grid
                                        item
                                        md={12}
                                        style={{ textTransform: "capitalize" }}
                                    >
                                        <hr className="w-100" />
                                        <h5>
                                            Follow these steps to complete the
                                            configuration on your Shopify store:
                                        </h5>
                                        {(() => {
                                            const STEPS = [
                                                "On the Settings page, enable the Test Mode toggle to use test data.",
                                                "In your Shopify admin, go to Apps, open the Diamonds on Call app, and pin it to the menu for easier access.",
                                                "To add the Diamonds on Call UI, go to Online Store ▶ Customize and navigate to the page where you want to add it.",
                                                "Click Add section ▶ Apps, then select the Doc Search Diamonds widget and add it to the page.",
                                                "Preview and save the theme, then refresh your storefront to see the Diamonds on Call UI (it shows test data in Test Mode).",
                                                "Test checkout: add a Diamonds on Call item and proceed to checkout — availability will be verified during checkout.",
                                                "Test order: complete the test payment for the Diamonds on Call items and place the order — the order will be created in the Diamonds on Call portal after payment succeeds.",
                                                "When testing is complete, ask your sales executive to enable Live Mode.",
                                                "In the Diamonds on Call portal (Diamond Feed), disable Test Mode, then refresh the storefront to display live data.",
                                            ];

                                            return (
                                                <div className="p-4">
                                                    {STEPS.map((step, idx) => (
                                                        <li
                                                            key={idx}
                                                            className="font-size-lg text-semibold my-1"
                                                        >
                                                            {step}
                                                        </li>
                                                    ))}
                                                </div>
                                            );
                                        })()}
                                    </Grid>
                                )}
                            </>
                        ) : (
                            ""
                        )}
                    </Grid>
                </Form>
            </FormikProvider>
            {!setup ? (
                <SwalWarn
                    show={swalopen.open}
                    message={swalopen.message}
                    onHide={() =>
                        setSwalOpen((prev) => ({ ...prev, open: false }))
                    }
                    onClose={() =>
                        setSwalOpen((prev) => ({ ...prev, open: false }))
                    }
                    responseOnOk={swalopen.okFunction}
                />
            ) : (
                ""
            )}
        </>
    );
}
